import * as React from 'react';
import { useSelector } from 'react-redux';

import { useCianMortgageUrl } from './hooks';
import { trackMortgageBannerClick, trackMortgageBannerShow } from './tracking';
import { Mortgage } from '../../components/Mortgage';
import { selectMortgage } from '../../selectors/promosPage';

export const MortgageContainer = () => {
  const url = useCianMortgageUrl();
  const mortgageInfo = useSelector(selectMortgage);

  const banksMoreCount = mortgageInfo.allBanksCount - mortgageInfo.banksLogo.length;

  return (
    <Mortgage
      banksLogo={mortgageInfo.banksLogo}
      banksMoreCount={banksMoreCount}
      buttonText={mortgageInfo.buttonText}
      description={mortgageInfo.description}
      onBannerClick={trackMortgageBannerClick}
      onBannerShow={trackMortgageBannerShow}
      url={url}
    />
  );
};
